import {STATUS_MODEL} from "../../../../../enums/statusEnum";
import {permissionObj} from "../../../../../Helpers/permission";
import {useTranslation} from "react-i18next";
import {ACCESS_POINT_MODEL, ACTIVITY_LIST_MODEL, INVITATION_VIEW_TYPE, invitationInTime} from "../Model/Model";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {CRITERIA_MODEL} from "../../../../../components/table/Model/TableModel";
import {SearchByFilters} from "../../../../../reduxToolkit/Search/SearchApi";
import {DATA_TYPE_MODEL, ORDER_MODEL, SEARCH_OPERATION_MODEL} from "../../../../Modals/Model/Model";
import {fieldModelName} from "../../../../../enums/fieldModelEnum";
import {TABLES} from "../../../../../Apis/Tables";
import {GetUserDetailForUpdate} from "../../../../../reduxToolkit/Contractor/ContractorApi";
import routes from "../../../../../Routes/routes";
import {useNavigate} from "react-router-dom";
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 * @param {Object} itemSelected - The invitation item currently selected to show details for.
 * @param showIdentityValidationButton  Flag to determine whether the identity validation button
 * should be displayed. If true, the button will be visible to the user.
 * @param Integer viewType - Controls view-specific logic. If set to "HISTORY (2)", access point logs are fetched.
 */

export const InvitationDetailsModalApp =({itemSelected, showIdentityValidationButton, viewType, backUrl})=> {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [activities, setActivities] = useState({...ACTIVITY_LIST_MODEL});
    const [activitiesCount, setActivitiesCount] = useState(1);
    const [accessPoints, setAccessPoints] = useState([]);
    const [identityValidationStatus, setIdentityValidationStatus] = useState(null);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const {permission} = useSelector((state) => state.authenticatioauthennSlice);
    const isOverdue = !invitationInTime(itemSelected?.endDate) ? STATUS_MODEL.OVERDUE : null;

    useEffect(() => {
        dispatch(GetUserDetailForUpdate(itemSelected?.visitorId)).then(({payload:{data:{data}}}) => {
            if(data?.id) setIdentityValidationStatus(data?.identityValidation?.id);
        });
    },[]);

    useEffect(() => {
        if(!itemSelected || !identityValidationStatus) return;
        let aux = {...activities};
        let cont = 1;
        let disabled = true;

        aux = {...aux,
            APPROVAL_STATUS: {
                ...aux.APPROVAL_STATUS,
                ...aux.APPROVAL_STATUS[itemSelected?.approvalStatusId],
                url: `${routes.approvalTracker?.main}${TABLES.USER_INVITATION}/${itemSelected?.id}/${itemSelected?.approvalFlowId}`,
                id : itemSelected?.id
            }
        };

        if(itemSelected?.approvalStatusId === STATUS_MODEL.PENDING_REVIEW) cont++;
        if(itemSelected?.approvalStatusId === STATUS_MODEL.APPROVED) disabled = false;
        if((!DEV && !permission.includes(permissionObj?.WEB_APPROVAL_FLOW_READ))
            || !itemSelected?.approvalFlowId
            || isOverdue
            || itemSelected?.visitorStatusId === STATUS_MODEL.REJECTED)
                aux = {...aux, APPROVAL_STATUS: {...aux.APPROVAL_STATUS, button:null}};

        aux = {...aux,
            VISITOR_STATUS: {
                ...aux.VISITOR_STATUS,
                ...aux.VISITOR_STATUS[itemSelected?.visitorStatusId]
            }
        };
        if(itemSelected?.visitorStatusId !== STATUS_MODEL.UNATTENDED) cont++;

        aux = {...aux,
                STATUS: {
                    ...aux.STATUS,
                    ...aux.STATUS[itemSelected?.statusId],
                    buttonDisabled: disabled,
                    id: itemSelected.id
                }
        };
        if(itemSelected?.statusId === STATUS_MODEL.APPROVED) cont++;
        if((!DEV && !permission.includes(permissionObj?.WEB_VISITOR_INVITATION_STATUS_DOCUMENTATION_READ))
            || isOverdue
            || itemSelected?.visitorStatusId === STATUS_MODEL.REJECTED)
                aux = {...aux, STATUS: {...aux.STATUS, button:null}};

        if(identityValidationStatus){
            aux = {...aux, IDENTITY_VALIDATION: {
                    ...aux.IDENTITY_VALIDATION,
                    ...aux.IDENTITY_VALIDATION[identityValidationStatus],
                    buttonDisabled: disabled,
                    showIdentityValidationButton:showIdentityValidationButton,
                    id: itemSelected.visitorId
                }};
        }

        if(identityValidationStatus === STATUS_MODEL.VALIDATED) cont++;
        if((!DEV && !permission.includes(permissionObj?.WEB_VISITOR_INVITATION_STATUS_IDENTIFY_READ))
            || isOverdue
            || itemSelected?.visitorStatusId === STATUS_MODEL.REJECTED)
                aux = {...aux, IDENTITY_VALIDATION: {...aux.IDENTITY_VALIDATION, button:null}};

        setActivities(aux);
        setActivitiesCount(cont);

        if(viewType === INVITATION_VIEW_TYPE.HISTORY){
            const criteriaList = new Array();
            const option = TABLES.USER_ACCESS_LOG;
            criteriaList.push(userCriteria());
            criteriaList.push(betweenDateCriteria());
            const body = {
                key:"",
                pagination: null,
                model: option,
                searchCriteriaList: criteriaList,
            };
            dispatch(SearchByFilters({ option, body, showSuccessMsg:false })).then(({ payload: {data: { data }}}) => {
                if(data?.length > 0){
                    let aux = [];
                    data.forEach((point) => {
                       aux.push(ACCESS_POINT_MODEL.set(point));
                    });
                    setAccessPoints(aux);
                }
            });
        }
    }, [itemSelected, identityValidationStatus]);

    const goRoutes = (url, id = null) => {
        if(id){
            navigate(url, {
                state: { id: id, backUrl:{...backUrl} }
            });
            return;
        }
       navigate(url);
    }

    const userCriteria = () => {
        return CRITERIA_MODEL.set({
            "dataOption": SEARCH_OPERATION_MODEL.AND,
            "fieldType": DATA_TYPE_MODEL.UUID,
            "filterKey": fieldModelName.user,
            "operation": SEARCH_OPERATION_MODEL.EQ,
            "sort": ORDER_MODEL.ASC,
            "table": TABLES.USER_ACCESS_LOG,
            "values": [itemSelected?.visitorId]
        });
    }

    const betweenDateCriteria = () => {
        return CRITERIA_MODEL.set({
            "dataOption": SEARCH_OPERATION_MODEL.AND,
            "fieldType": DATA_TYPE_MODEL.LONG,
            "filterKey": fieldModelName.createdAt,
            "operation": SEARCH_OPERATION_MODEL.BT,
            "sort": ORDER_MODEL.ASC,
            "table": TABLES.USER_ACCESS_LOG,
            "from": itemSelected?.startDate,
            "to": itemSelected?.endDate
        });
    }

    return{
        t,
        activities,
        activitiesCount,
        accessPoints,
        isOverdue,
        goRoutes
    }
}
